import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { combineValidators, isRequired } from 'revalidate';
import { reduxForm, Field } from 'redux-form';
import CustomTextInput from '../../common/form/CustomTextInput';
import { loginAuth } from './redux/authApi';
import { useUnamePass } from '../../common/helpers/othersHelpers';
import LoadingButton from '../../common/layout/LoadingButton';
import SectionBody from './part/SectionBody';
import Herobody from './part/Herobody';
import BodyAuth from './part/BodyAuth';
import { useWindowSize } from '../../common/helpers/sizeHelper';
import RegisterParents from './part/RegisterParents';
import LoginIcon from '../../common/icons/LoginIcon';

function mapState(state) {
  return {
    auth: state.auth,
    loading: state.async.loading,
  };
}

const actions = {
  loginAuth,
};

const validate = combineValidators({
  username: isRequired({ message: 'Username is required' }),
  password: isRequired({ message: 'Password is required' }),
});

function Login(props) {
  const { loginAuth, handleSubmit, auth, error, loading } = props;
  const uPass = useUnamePass();

  let windowSize = useWindowSize();

  const handleLogin = async (authData) => {
    await loginAuth(authData);
  };

  if (auth?.isAuth && !auth.registerParents)
    return <Redirect to='/dashboard' />;
  if (auth?.isAuth && auth.registerParents)
    return <Redirect to='/register-2' />;

  if (uPass)
    return (
      <SectionBody>
        <Herobody
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ffffff',
          }}
        >
          <LoadingButton />
        </Herobody>
      </SectionBody>
    );

  return (
    <>
      <BodyAuth
        title={'Selamat Datang di Portal Sekolah'}
        width={
          windowSize[0] < 400
            ? windowSize[0] > 365
              ? 365
              : windowSize[0]
            : 400
        }
      >
        <form onSubmit={handleSubmit(handleLogin)} autoComplete='off'>
          <Field
            name='username'
            type='text'
            component={CustomTextInput}
            placeholder='Username'
            autoComplete='new-password'
            label='Username'
            icon='user'
          />
          <Field
            name='password'
            type='password'
            autoComplete='new-password'
            component={CustomTextInput}
            placeholder='Password'
            label='Password'
            icon='lock'
          />
          <div className='field has-text-centered' style={{ marginTop: 25 }}>
            {error && <p className='help is-danger'>{error}</p>}
            <button
              disabled={loading}
              type='submit'
              style={{ marginRight: 10 }}
              className={`button is-info is-small is-rounded${
                loading ? ' is-loading' : ''
              }`}
            >
              {!loading && <LoginIcon size={15} color={'#ffffff'} />}
              <span className='ml-1'>Login</span>
            </button>
          </div>
        </form>
        <RegisterParents />
      </BodyAuth>
    </>
  );
}

export default withRouter(
  connect(mapState, actions)(reduxForm({ form: 'formLogin', validate })(Login))
);
